function toLowerCamelCase(text) {
  text = (text || '').trim();
  if (text) {
    text = text[0].toLowerCase() + text.substring(1);
  }
  return text;
}

export default toLowerCamelCase;
